import styled from "styled-components";

export const Container = styled.header`
  background-color: var(--red);

  img {
    width: 120px;
  }
`;

export const Content = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
`;

export const Security = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .FaLock {
    color: white;
  }

  p,
  strong {
    color: white;
    font-size: 15px;
  }
`;

export const TextSecurity = styled.div`
  margin: 5px;
  p {
    margin: -10px 0px 5px 0px;
  }
`;
